export const operations = ["+", "-", "*", "/"];
export const numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

export const symbols = {
    "x": "x",
    "^": "^2",
    "d": "\\frac{d}{dx}(",
    "v": ")",
    "+": "+",
    "-": "-",
    "*": "*",
    "/": "/",
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
};